import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import DebtorLedger from "./DebtorLedger";

export default {
    storageKey: StorageKey.report_creditor_ledger,
    getReportLabel: () => t`Creditor Ledger`,
    required: DebtorLedger.required,
    defaulto: DebtorLedger.defaulto,
    getColumns: DebtorLedger.getColumns,
};
